/**
 * List Schema of TokenPush
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'

/* TODO: review generated schema */
export class ListTokenPushSchema extends Schema {
  readonly name = 'ListTokenPush'

  readonly fieldSet: FieldSet<TokenPush> = {
    idTokenPushPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    token: (): FieldComponent => ({
      is: Component.Render,
    }),
    modeloAparelho: (): FieldComponent => ({
      is: Component.Render,
    }),
    marcaAparelho: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
